import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// const apiUrl = process.env.REACT_APP_API_ROOT_URL;
export const menuSlide = createSlice({
    name: "menu",
    initialState: {
        menuListData: null,

        menuDetailSuccess: false,
        menuDetailFail: false,
        menuDetailResponseData: null,
        menuDetailErrorDetailData: null,
    },
    reducers: {
        doGetMenuListSuccess: (state, action) => {
            state.menuListData = action.payload.data;
        },
        doGetMenuListFail: (state, action) => {
            state.menuListData = [];
        },
        doGetMenuDetailSuccess: (state, action) => {
            state.menuDetailSuccess = true;
            state.menuDetailFail = false;
            state.menuDetailResponseData = action.payload.data;
        },
        doGetMenuDetailFail: (state, action) => {
            state.menuDetailSuccess = false;
            state.menuDetailFail = true;
            state.menuDetailErrorDetailData = action.payload.data;
        },
        resetMenuStateSuccess: (state, action) => {
            state.menuDetailSuccess = action.payload;
            state.menuDetailFail = action.payload;
            state.menuDetailResponseData = null;
            state.menuDetailErrorDetailData = null;
        },
    },
});

export const doGetMenuList = (param) => async (dispatch) => {
    try {
        let url = `/api/customer/menu`;

        const response = await axios.get(url);
        dispatch(doGetMenuListSuccess(response.data));
    } catch (error) {
        dispatch(doGetMenuListFail(error.response));
    }
};

export const doGetMenuDetail = (param) => async (dispatch) => {
    try {
        const url = `/api/customer/menu/${param.menu_id}`;

        const response = await axios.get(url);
        dispatch(doGetMenuDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetMenuDetailFail(error.response));
    }
};

export const resetMenuState = () => async (dispatch) => {
    dispatch(resetMenuStateSuccess(false));
 };

export const { 
    doGetMenuListSuccess, 
    doGetMenuListFail,
    doGetMenuDetailSuccess,
    doGetMenuDetailFail,
    resetMenuStateSuccess,
} = menuSlide.actions;

export const getMenuList = (state) => state.menu?.menuListData;

export const getMenuDetail = (state) => state.menu?.menuDetailResponseData;
export const getMenuDetailErrorDetailData = (state) => state.menu?.menuDetailErrorDetailData;
export const getMenuDetailSuccess = (state) => state.menu?.menuDetailSuccess;
export const getMenuDetailFail = (state) => state.menu?.menuDetailFail;


export default menuSlide.reducer;
